export const MAIN_ID = {
  SUB_CONTRACTOR: 'subContractor',
  GENERAL_CONTRACTOR: 'generalContractor',
  DEALER_RETAILER_SUPPLIER: 'dealerRetailerSupplier',
  MANUFACTURER_DISTRIBUTOR: 'manufacturerDistributor',
  ARCHITECT_INTERIOR_DESIGNER: 'architectInteriorDesigner',
  ENGINEER_CONSULTANT: 'engineerConsultant',
  DEVELOPER_PROPERTY_OWNER: 'developerPropertyOwner',
  DEVELOPER_PROPERTY_OWNER_YES: 'developerPropertyOwneryes',
  DEVELOPER_PROPERTY_OWNER_NO: 'developerPropertyOwnerno',
  OTHER: 'other',
  OTHER_YES: 'otheryes',
  OTHER_NO: 'otherno',
}

export type OnboardingCategories = typeof MAIN_ID[keyof typeof MAIN_ID]

export const ID = {
  RECEIVABLE_FINANCING: 'receivableFinancing',
  MATERIAL_AND_SERVICE_FINANCING: 'materialAndServiceFinancing',
  ACCEPT_ACH_CARD: 'acceptACHAndCardPayments',
  OFFER_EARLY_PAYMENT: 'offerEarlyPaymentToSubsAndVendors',
  OFFER_TRADE_CREDIT: 'offerTradeCredit',

  //legacy onboarded actions, that we still need to support
  GET_PREQUALIFIED: 'getPrequalified',
  GET_PAID_FAST_ACH: 'getPaidFastACHCard',
}

export const HOME_ID = {
  GET_PAID_FAST_ACH: 'getPaidFastACHCard',
  UPLOAD_INVOICE_SUP: 'uploadInvoiceSupplierContractor',
  UPLOAD_INVOICE_VENDORS: 'uploadInvoiceVendors',
}

export const CustomerType = {
  GET_PAID: 'GET_PAID',
  PAY: 'PAY',
  PAY_ONLY: 'PAY_ONLY',
}
